module.exports = __webpack_public_path__ + "img/account-icon.96dade7b.svg";